import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import coverService from "./coverService";
import { flashMessage as flash } from "./../../../utils/flash/index";

const initialState = {
  all_covers: [],
  single_cover: null,
  isLoading: false,
  isSuccess: false,
  createSuccess: false,
  updateSuccess: false,
  isUpdating: false,
  isError: false,
};

const coverSlice = createSlice({
  initialState,
  name: "cover",
  reducers: {
    resetCover: (state) => initialState,
    resetCoverStatus: (state) => {
      state.isError = false;
      state.isSuccess = false;
      state.isLoading = false;
      state.single_cover = null;
      state.createSuccess = false;
      state.updateSuccess = false;
      state.isFetching = false;
    },
    resetUpdateCover: (state) => {
      state.updateSuccess = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createCover.pending, (state) => {
        state.isLoading = true;
        flash("info", "Cover is creating...");
      })
      .addCase(createCover.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        if (!payload.errors) {
          state.createSuccess = true;
          flash("success", payload.message);
        } else if (typeof payload.errors == "string") {
          flash("error", payload.errors);
        } else {
          let key = Object.keys(payload.errors)[0];
          let message = payload.errors[key][0];
          flash("error", message);
        }
      })
      .addCase(createCover.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })
      .addCase(updateCover.pending, (state) => {
        state.isLoading = true;
        flash("info", "Cover is updating...");
      })
      .addCase(updateCover.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        if (!payload.errors) {
          state.updateSuccess = true;
          flash("success", payload.message);
        } else if (typeof payload.errors == "string") {
          flash("error", payload.errors);
        } else {
          let key = Object.keys(payload.errors)[0];
          let message = payload.errors[key][0];
          flash("error", message);
        }
      })
      .addCase(updateCover.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })
      .addCase(getAllCovers.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllCovers.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        if (!payload.errors) {
          state.isSuccess = true;
          state.all_covers = payload;
        } else if (typeof payload.errors == "string") {
          flash("error", payload.errors);
        } else {
          let key = Object.keys(payload.errors)[0];
          let message = payload.errors[key][0];
          flash("error", message);
        }
      })
      .addCase(getAllCovers.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })
      .addCase(getSingleCover.pending, (state) => {
        state.isLoading = true;
        state.single_cover = null;
      })
      .addCase(getSingleCover.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        if (!payload.errors) {
          state.isSuccess = true;
          state.single_cover = payload.edit_cover;
        } else if (typeof payload.errors == "string") {
          flash("error", payload.errors);
        } else {
          let key = Object.keys(payload.errors)[0];
          let message = payload.errors[key][0];
          flash("error", message);
        }
      })
      .addCase(getSingleCover.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      });
  },
});

export const createCover = createAsyncThunk(
  "/cover/create",
  async (data, thunkAPI) => {
    try {
      return await coverService.createCover(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getAllCovers = createAsyncThunk(
  "/cover/getAll",
  async (pageNum, thunkAPI) => {
    try {
      return await coverService.getAllCover(pageNum);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getSingleCover = createAsyncThunk(
  "/cover/getSingle",
  async (id, thunkAPI) => {
    try {
      return await coverService.getSingleCover(id);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const updateCover = createAsyncThunk(
  "/cover/update",
  async (id, thunkAPI) => {
    try {
      return await coverService.updateCover(id);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const { resetCover, resetCoverStatus, resetUpdateCover } =
  coverSlice.actions;
export default coverSlice.reducer;
